import {Component} from '@angular/core';
import {AuthService} from "../../service/auth.service";
import {NavService} from "../../service/nav.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  constructor(public authService: AuthService, public navService: NavService) {

  }

}



// WEBPACK FOOTER //
// D:/AppDev/meetup/kla-firebase-poker/web/src/app/component/home/home.component.ts